<template>
  <div class="payWay">
    <van-radio-group
      class="pageCard"
      v-model="checked"
      :disabled="sellData.sell_price <= 0"
    >
      <van-cell-group>
        <van-cell
          @click="showCoupons(1)"
          class="balancePay coupons"
          v-if="coupon_list.length > 0"
        >
          <template #title>
            <van-icon name="coupon-o" />
            <span>卡券抵扣</span>
          </template>
          <div class="balanceRight">
            <div class="right">
              <span class="labels">{{ cname }}</span>
              <van-icon name="arrow" />
            </div>
          </div>
        </van-cell>
        <van-cell
          @click="showCoupons(2)"
          class="balancePay coupons"
          v-if="couponsBalanceList.length > 0"
        >
          <template #title>
            <van-icon name="coupon-o" />
            <span>通用券</span>
            <span class="tag" v-if="num > 0">已选{{ num }}张</span>
          </template>
          <div class="balanceRight">
            <div class="right">
              <span class="labels" v-if="couponsDeduct > 0"
                >抵扣￥{{ $formatMoney(couponsDeduct, 1) }}</span
              >
              <van-icon name="arrow" />
            </div>
          </div>
        </van-cell>
        <van-cell
          clickable
          @click="checkedPrice"
          :class="isWechatPay ? 'balancePay' : 'balancePay2'"
          v-if="isShowBalance()"
        >
          <template #title>
            <i class="iconfont iconu728 balance"></i>
            <span class="val">账户余额：￥{{ $formatMoney(balance, 1) }}</span>
          </template>
          <div class="balanceRight">
            <div class="right">
              <span
                class="labels deduct"
                v-if="service_price > 0 && checked && showDeduct"
                >抵扣￥{{ deduction() }}</span
              >
              <van-checkbox
                :disabled="
                  sellData.sell_price == -1 ||
                  balance == 0 ||
                  num > 0 ||
                  service_price == 0
                "
                class="radios"
                v-model="checked"
                ref="checkboxes"
                checked-color="var(--greenColor)"
              ></van-checkbox>
            </div>
            <br />
            <span
              class="servicefee"
              v-if="fee_discount > 0 && checked && balance >= service_price"
              :style="
                !this.isWechatPay ? 'margin-right:0;' : 'margin-right:15px;'
              "
              >（{{ dValue >= 0 ? "含" : ""
              }}{{ balance == service_price ? "还需支付" : "" }}服务费￥{{
                $formatMoney((service_price * fee_discount) / 100, 1)
              }}）</span
            >
          </div>
        </van-cell>
        <van-cell class="wechatModel" clickable v-if="isWechatPay">
          <template #title>
            <i class="iconfont iconweixinzhifu weixin"></i>
            <span class="val">微信支付</span>
          </template>
          <template #right-icon>
            <span class="labels" v-if="!checked & (service_price > 0)"
              >￥{{ $formatMoney(service_price, 1) }}</span
            >
            <span class="labels" v-else-if="!checked && dValue <= 0"
              >￥{{ $formatMoney(-dValue, 1) }}</span
            >
            <span class="labels" v-else-if="checked && dValue < 0"
              >￥{{ $formatMoney(-dValue, 1) }}</span
            >
            <span class="labels" v-else>￥0</span>
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>
    <div class="agreement">
      <van-checkbox
        v-model="registerAndInfoChecked"
        shape="square"
        icon-size="14px"
        label-disabled
        >已阅读并同意
        <div class="agreement-content">
          <span class="text" @click="agreementClickHandle()"
            >《用户注册协议及用户信息使用须知》</span
          >
        </div>
      </van-checkbox>
    </div>
    <van-button
      class="pageDefaultRadius pageBannarShadow pageFontWeight clickPay"
      color="var(--depYelColor)"
      :disabled="disabeledButton()"
      @click="onComfirm"
      block
      id="paybtn"
    >
      <span v-if="checked && dValue < 0 && isWechatPay & (cid == '')"
        >支付 {{ $formatMoney(-dValue, 1) }} 元</span
      >
      <span v-else-if="(checked && dValue >= 0) || !isWechatPay">{{
        btntext
      }}</span>
      <span v-else-if="!checked && isWechatPay & (cid == '')">
        {{
          $formatMoney(service_price, 1) > 0
            ? "支付 " + $formatMoney(service_price, 1) + " 元"
            : btntext
        }}</span
      >
      <span v-else>{{ btntext }}</span>
    </van-button>
    <RegisterAndInfo ref="registerAndInfo"></RegisterAndInfo>
  </div>
</template>
<script>
import { submitPayOrder, annuanVerificationOrder } from "api/submit";
import { wechatPay } from "api/wechatSDK";
import RegisterAndInfo from "../views/agreement/user/registerAndInfo.vue";
/*global $ */

export default {
  props: {
    couponsId: {
      type: String,
      default: "",
    },
    couponsName: String,
    placeholder: {
      type: String,
      default: () => "请输入账号",
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    sellData: {
      type: Object,
      default: () => ({}),
    },
    showConfirm: {
      type: Boolean,
      default: true,
    },
    isOnline: {
      type: Boolean,
      default: true,
    },
    isOilCard: {
      type: Boolean,
      default: false,
    },
    tips: {
      type: String,
      default: "",
    },
    discount: {
      type: Number,
      default: 0,
    },
    isWechatPay: {
      type: Boolean,
      default: true,
    },
    isSend: {
      type: Boolean,
      default: false,
    },
    isMember: {
      type: Boolean,
      default: false,
    },
    isactive: {
      type: Number,
      default: 0,
    },
    phone: {
      type: String,
      default: "",
    },
    type: {
      type: Number,
    },
    balance: {
      type: Number,
      default: () => 0,
    },
    typeName: String,
    vip_discount: Number,
    discount_coupons: {
      type: Array,
      default: () => [],
    },
    coupon_list: {
      type: Array,
      default: () => [],
    },
    can_use_power: Boolean,
    couponsBalanceList: {
      type: Array,
      default: () => [],
    },
    couponsDeduct: {
      type: Number,
      default: 0,
    },
    accountIsValid: {
      type: Boolean,
      default: true,
    },
    ident: String,
    carNo: String,
    carType: String,
    detection: String,
    setMeal: String,
    mobile: String,
    agreeChecked: Boolean,
    appointTime: String,
    userLoc: String,
    userTime: String,
  },
  components: {
    RegisterAndInfo,
  },
  data() {
    return {
      radio: "",
      checked: false,
      discount_checked: false,
      remark: "请选择充值面值",
      isShow: false,
      btntext: "立即提交",
      showDeduct: false,
      cid: "",
      cname: "",
      fee_discount: 0,
      discount_coupon: "",
      discount_money: 0,
      discount_time: 0,
      exchange_checked: false,
      card_id: "",
      now_price: 0, //用于通用卡券计算
      service_price: 0,
      btndisabled: false, //按钮禁用
      dValue: 0, //实时金额
      registerAndInfoChecked: true,
    };
  },
  created() {
    this.fee_discount = this.isMember ? 0 : this.discount;
    this.onComfirm = this.$debounce(this.onComfirm, 500);
    // console.log(this.couponsBalanceList);
  },
  computed: {
    //当前选中卡券数量
    num() {
      let path = this.$route.path;
      let that;
      if (path == "/onLineIndex") {
        that = this.$parent.$parent;
      } else {
        that = this.$parent;
      }
      return that.couponsBalanceChecked == undefined
        ? 0
        : that.couponsBalanceChecked.length;
    },
  },
  watch: {
    couponsId(val) {
      let that = this;
      if ((val != "") & (val != null)) {
        that.cid = val;
        that.cname = that.couponsName;
        that.sellData.sell_price = -1;
        that.btntext = "立即提交";
        // that.dValue=0;
      }
    },
    //当前切换价格变动
    sellData() {
      this.now_price = this.sellData.sell_price;
      this.cid = "";
      let path = this.$route.path;
      let that;
      if (path == "/onLineIndex") {
        that = this.$parent.$parent;
      } else {
        that = this.$parent;
      }
      that.couponsBalanceChecked = [];
      that.number = 0;
      that.sell_price = this.sellData.sell_price;
      this.service_price = this.sellData.sell_price;
      this.price_change();
    },
    //通用卡券抵扣金额变动
    couponsDeduct() {
      this.checked = false;
      this.price_change();
    },
    checked() {
      let path = this.$route.path;
      if (path == "/onLineIndex") {
        let that = this.$parent.$parent;
        that.balanceChecked = !true;
      }
    },
  },
  mounted() {
    this.service_price = this.sellData.sell_price;
  },
  methods: {
    //价格变动监听
    price_change() {
      let that = this;
      that.service_price = that.sellData.sell_price;

      //是否为会员
      if (that.isMember & (that.vip_discount > 0)) {
        that.service_price = that.service_price * (that.vip_discount / 100);
      }
      let val;
      //通用券抵扣
      if (that.couponsDeduct > 0) {
        that.service_price = that.now_price - that.couponsDeduct;
        val = that.now_price - that.couponsDeduct;
      } else {
        val = (
          that.balance -
          (that.service_price + (that.service_price * that.fee_discount) / 100)
        ).toFixed(2);
      }
      //无通用券
      if (
        !that.isWechatPay &&
        that.balance >= 0 &&
        that.couponsBalanceList.length <= 0
      ) {
        console.log("计算1");
        that.checked = true;
        $(".balance").unbind();
        if (val < 0) {
          console.log(val);
          that.btntext = "余额不足";
          if (that.balance >= that.sellData.sell_price) {
            that.showDeduct = true;
          } else {
            that.showDeduct = false;
          }
          $(".btn").addClass("noPay");
        } else {
          console.log(val);
          that.btntext = "立即提交";
          that.toggle();
          that.showDeduct = true;
          $(".balanceRight br").show();
          $(".btn").removeClass("noPay");
        }
        that.dValue = parseFloat(val);
      } else {
        //支付手续费
        let fee_discount = that.fee_discount;
        let finallyMonery = that.$formatMoney(
          that.sellData.sell_price +
            (that.sellData.sell_price * fee_discount) / 100
        );
        let balance = that.balance;
        that.isShow = finallyMonery <= balance ? false : true;
        that.showDeduct = true;
        if (
          (that.params.deno == undefined) &
          (that.sellData.sell_price == -1)
        ) {
          console.log(that.params.deno);
          that.btntext = "请输入任意金额";
        } else if (
          (that.couponsDeduct < that.sellData.sell_price) &
          (that.couponsDeduct > 0)
        ) {
          this.btndisabled = true;
          that.btntext = "卡券余额不足";
        } else {
          console.log("计算2", val);
          that.btntext = "立即提交";
        }
        that.checked = false;
        that.dValue = parseFloat(val);
      }
    },
    //抵扣金额
    deduction() {
      if (this.dValue >= 0) {
        if ((this.fee_discount > 0) & this.isShow) {
          return this.$formatMoney(
            this.service_price + (this.service_price * this.fee_discount) / 100,
            1
          );
        } else {
          return this.$formatMoney(this.service_price, 1);
        }
      } else {
        return this.$formatMoney(this.balance, 1);
      }
    },
    //是否显示余额
    isShowBalance() {
      if (
        this.$parent.type == "jygd" &&
        !this.isWechatPay &&
        this.balance > 0
      ) {
        return true;
      } else if (this.balance > 0) {
        return true;
      } else {
        return false;
      }
    },
    //按钮是否禁用
    disabeledButton() {
      // 充值账号校验
      if (!this.accountIsValid) {
        return true;
      }
      //微信支付
      if (this.isWechatPay) {
        if (this.sellData.sell_price >= 0) {
          return false;
        } else {
          return true;
        }
      }
      //无微信
      else {
        //有通用券
        if (this.couponsBalanceList.length > 0) {
          if (
            (this.sellData.sell_price >= 0) &
            (this.couponsDeduct > 0) &
            (this.dValue <= 0)
          ) {
            return false;
          } else if (
            this.dValue >= 0 &&
            (this.balance > 0) & this.checked & (this.num <= 0)
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          //无通用券、使用余额
          if (
            (this.balance > 0) &
            (this.dValue >= 0) &
            (this.sellData.sell_price > 0)
          ) {
            return false;
          } else {
            return true;
          }
        }
        // if (
        //   (this.sellData.sell_price < 0 || this.dValue < 0) &
        //   (this.cid == "") &
        //   (this.couponsDeduct == 0)
        // ) {
        //   return true;
        // }
        // //通用券优先
        // else if (
        //   !this.isWechatPay &
        //   (this.dValue < 0) &
        //   (this.couponsBalanceList.length > 0)
        // ) {
        //   return true;
        // } else {
        //   return false;
        // }
      }
    },
    showCoupons(val) {
      let path = this.$route.path;
      let number = 0;
      let that;
      if (path == "/onLineIndex") {
        that = this.$parent.$parent;
      } else {
        that = this.$parent;
      }
      that.number = number;
      if (val == 1) {
        that.showDialogs = true;
      } else {
        console.log(this.params.card_id);
        console.log(this.sellData.sell_price);
        if (
          (this.params.card_id != undefined) &
          (this.sellData.sell_price == 0)
        ) {
          if (number == 0) {
            this.$error("当前卡券已抵扣支付金额");
          } else {
            that.couponsBalanceShow = true;
          }
        } else {
          that.couponsBalanceShow = true;
        }
      }
    },
    //选中余额抵扣
    checkedPrice() {
      if (this.num > 0) {
        return;
      }
      if (this.service_price == 0 && this.params.deno <= 0) {
        return;
      }
      this.price_change();
      if (
        this.sellData.sell_price != -1 &&
        this.balance > 0 &&
        this.isWechatPay
      ) {
        this.$refs.checkboxes.toggle();
      } else if (
        this.$parent.type == "jygd" &&
        this.sellData.sell_price != -1 &&
        this.balance > 0
      ) {
        this.$refs.checkboxes.toggle();
      }
    },
    toggle() {
      if (this.sellData.sell_price && this.balance && this.isWechatPay) {
        this.$refs.checkboxes.toggle();
      }
      let fee_discount = this.fee_discount;
      let finallyMonery = this.$formatMoney(
        this.service_price + (this.service_price * fee_discount) / 100
      );
      let balance = this.balance;
      this.isShow = finallyMonery <= balance ? false : true;
    },
    onComfirm() {
      let price = this.sellData.sell_price;
      if (price < 0) {
        // this.$error("请选择充值数值");
        return false;
      }
      let path = this.$route.path;
      let that = path == "/onLineIndex" ? this.$parent.$parent : this.$parent;
      let cards = that.cards;
      var data = {};
      //纯券支付
      if ((cards.length > 0) & (this.dValue == 0)) {
        data.payment_mode = "coupon";
      }
      //纯微信
      else if ((cards.length <= 0) & (this.dValue < 0)) {
        data.payment_mode = "wechat";
      }
      //混合
      else {
        data.payment_mode = "mix";
      }
      this.alertComfirm(data);
    },
    alertComfirm(data) {
      if (!this.registerAndInfoChecked) {
        this.$error("请先阅读并勾选同意协议！");
        return false;
      }
      if (this.type == 3 && this.params.account == "") {
        this.$error(this.placeholder);
        // var button = document.getElementById("paybtn");
        this.$parent.msgAlert();
        return;
      }
      if (this.params.account) {
        this.params.account = this.params.account.toString().replace(/ /g, "");
      }
      if (this.showConfirm) {
        let info = "";
        let title = "";
        if (
          this.$getItem("appId") == "wxe963026ae3a4e4c8" &&
          this.phone != ""
        ) {
          info =
            "<p><span style='font-size:20px;color:red;font-weight:900;'>手机号码：" +
            this.phone +
            "</span> <br/> 请核对手机号码是否正确，订单提交后无法撤销！</p>";
          title = "提示";
        }

        if ((data.amount > 0) & (info == "")) {
          this.payOrder(data);
        } else {
          info = "您确定要支付吗？";
          if (this.ident == "examined") {
            if (
              !this.carNo ||
              !this.detection ||
              !this.setMeal ||
              !this.mobile
            ) {
              this.$error("带红星选项为必填项");
              return;
            }
            if (this.agreeChecked === false) {
              this.$error("请先阅读并勾选《机动车年检代办协议》");
              return;
            }
            this.$confirm(info, title).then(() => {
              this.payAnnualVerificationOrder(data);
            });
          } else {
            this.$confirm(info, title).then(() => {
              this.payOrder(data);
            });
          }
        }
      } else {
        //自定义支付
        this.$emit("onComfirm", data);
      }
    },
    payAnnualVerificationOrder(data) {
      //卡券余额抵扣
      let path = this.$route.path;
      let that = path == "/onLineIndex" ? this.$parent.$parent : this.$parent;
      let cards = that.cards;
      if (cards != undefined) {
        if (cards.length > 0) {
          data.couponIds = cards;
        }
      }
      if (this.type == 7 && this.isSend) {
        this.$emit("onComfirm", data);
        return;
      }
      this.$store.commit("setGlobalOrderType", 0);
      const data_ = {
        plateNumber: this.carNo,
        carType: this.carType,
        identity: this.detection,
        price: this.setMeal,
        consignee: this.userRealName,
        phone: this.mobile,
        appointTime: this.appointTime,
        userLoc: this.userLoc,
        userTime: this.userTime,
        ...data,
        ...this.params,
      };
      console.log(data_);
      this.$loading("支付中");
      annuanVerificationOrder(data_).then((res) => {
        this.$clear();
        if (res.status == 200) {
          this.$successSync("支付成功", () => {
            this.$push({
              path: "/orders?type=-1",
            });
          });
        } else {
          this.$error(res.message);
        }
      });
      return;
    },
    payOrder(data) {
      //卡券余额抵扣
      let path = this.$route.path;
      let that = path == "/onLineIndex" ? this.$parent.$parent : this.$parent;
      let cards = that.cards;
      if (cards != undefined) {
        if (cards.length > 0) {
          data.couponIds = cards;
        }
      }
      if (this.type == 7 && this.isSend) {
        this.$emit("onComfirm", data);
        return;
      }

      this.$store.commit("setGlobalOrderType", 0);
      const data_ = {
        ...data,
        ...this.params,
        sellPrice: this.sellData.sell_price,
      };

      // console.log(data, this.params, this.type);
      if (this.type == 8) {
        this.$emit("onComfirm", data_);
        return;
      }
      // var jsonData = this.$JsonMerge(data, this.params);
      this.$loading("支付中");
      submitPayOrder(data_).then((res) => {
        this.$clear();
        if (res.status == 200) {
          if (typeof res.data == "object" && res.data != null) {
            if (res.data.appId != undefined) {
              wechatPay(res.data);
            } else {
              this.$successSync("支付成功", () => {
                this.$push({
                  path: "/orders?type=-1",
                });
              });
            }
          } else {
            this.$successSync("支付成功", () => {
              this.$push({
                path: "/orders?type=-1",
              });
            });
          }
        } else {
          this.$error(res.message);
        }
      });
    },
    agreementClickHandle() {
      this.$refs["registerAndInfo"].show = true;
    },
  },
};
</script>

<style scoped lang="less">
.discount_coupons {
  background: inherit;
  color: #fff;
  .van-cell {
    padding: inherit;
    align-items: center;
    margin-bottom: 15px;
    box-shadow: #ccc 0 0 5px;
    background: red;
    color: #fff;
    border-radius: 10px;
    .van-cell__title {
      flex: inherit;
      /deep/ .van-tag {
        font-size: 12px;
      }
    }
    .van-cell__value {
      padding-left: 10px;
      text-align: left;
      color: #fff;
    }
    .van-radio {
      margin-right: 10px;
      color: #fff;
      border-color: #fff;
      border-width: 2px;
    }
    /deep/ .van-icon {
      border: 2px solid #f7f8fa;
    }
    /deep/ .van-checkbox__icon--checked {
      .van-icon {
        background-color: inherit;
        border-color: inherit;
      }
    }
    /deep/ .van-radio__icon--checked {
      .van-icon {
        background-color: inherit;
        border-color: inherit;
      }
    }
    .left {
      border-right: 2px solid #cccccc82;
    }
    .left_money {
      font-size: 26px;
      font-weight: bold;
      text-align: center;
      width: 65px;
      padding-right: 15px;
      border-right: 2px solid #cccccc82;
      span {
        font-size: 18px;
      }
    }
    .left_time {
      background: #fff;
      color: red;
      border-radius: 10px;
      display: flex;
      align-items: center;
      /* justify-content: center; */
      height: 20px;
      font-size: 12px;
      span {
        padding: 0px 5px;
      }
    }
    .right_name {
      font-size: 16px;
      font-weight: bold;
    }
    .right_time {
      font-size: 14px;
    }
  }
}
.pageCard {
  padding: 0;
  .van-cell-group {
    border-radius: 10px;
  }
  .wechatModel {
    border-radius: 0px 0px 10px 10px;
  }
  .balancePay {
    border-radius: 10px 10px 0px 0px;
  }
  .balancePay2 {
    border-radius: 10px;
  }
  .coupons {
    border-radius: 10px 10px 0px 0px;
    .balanceRight {
      display: flex;
      align-items: center;
    }
    .tag {
      font-size: 12px;
      padding: 0px 5px;
      margin-left: 5px;
      color: #fff;
      background: #f90;
      height: 15px;
      display: flex;
      align-items: center;
      border-radius: 5px 0px 5px 0px;
    }
  }
  .van-icon-coupon-o {
    display: flex;
    align-items: center;
    font-size: 20px;
    margin-right: 8px;
    color: var(--depYelColor);
  }
}
.payWay {
  .van-cell {
    padding: 10px;
    justify-content: space-between;
    font-size: var(--middleFont);
  }
  .van-cell:last-child {
    border-radius: 10px;
  }
  .van-cell::after {
    border-color: #d2d2d2;
    left: 0;
    right: 0;
  }
  .van-cell__title,
  .van-cell__value {
    flex: initial;
    justify-content: center;
    display: flex;
  }
  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border: none;
  }
  .iconfont {
    font-size: 22px;
    vertical-align: middle;
    margin-right: 8px;
  }
  .weixin {
    color: var(--greenColor);
  }
  .balance {
    color: var(--depYelColor);
  }
  .val {
    color: var(--assistantColor);
  }
  .labels {
    font-size: 16px;
    color: var(--redColor);
  }
  .labels:first-child {
    margin-right: 8px;
  }
  .van-checkbox {
    height: 24px;
  }
  .servicefee {
    margin-right: 15px;
    color: var(--redColor);
    font-size: 14px;
  }
  .agreement {
    margin-top: 15px;
    font-size: var(--smallFont);
    /deep/.van-checkbox__label {
      line-height: normal;
      color: #999;
    }
    .agreement-content {
      display: inline;
      .text {
        font-weight: 700;
      }
    }
    .van-checkbox {
      height: auto;
    }
  }
  .clickPay {
    margin-top: 20px;
    height: 50px;
    span {
      font-size: 16px;
    }
  }
  .right {
    display: flex;
    float: right;
    align-items: center;
  }
}
</style>
